import { render, staticRenderFns } from "./ServicesForm.vue?vue&type=template&id=10679510&scoped=true&"
import script from "./ServicesForm.vue?vue&type=script&lang=js&"
export * from "./ServicesForm.vue?vue&type=script&lang=js&"
import style0 from "./ServicesForm.vue?vue&type=style&index=0&id=10679510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10679510",
  null
  
)

export default component.exports